import { Box, styled } from '@mui/material';

export const ReleasesStatsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gridColumn: 'span 4',
  padding: theme.spacing(2),
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  background: theme.palette.grey[800],
  borderRadius: theme.spacing(1),
}));
